import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  IPackage,
  ISubscriptionBumpPackages,
  ISubscriptionPackages,
  ISubscriptionShortlistPackages,
} from '../../../core/models/models';

interface SubscriptionPackagesState {
  isLoading: boolean;
  error: string;
  packages: ISubscriptionPackages;
  selectedPackage: IPackage | null;
  bumpPackages: ISubscriptionBumpPackages[] | null;
  shortlistPackages: ISubscriptionBumpPackages[] | null;
  selectedAssignmentId: string;
  // selectedSubscriptionPackage: IPackage;
  selectedBumpPackage: ISubscriptionBumpPackages | null;
  selectedShortlistPackage: ISubscriptionShortlistPackages | null;
  purchaseType: 'package' | 'bump' | 'shortlist' | string | null;
}

const initialState: SubscriptionPackagesState = {
  isLoading: false,
  error: '',
  packages: {
    user_id: '',
    basic_packages: null,
    premium_packages: null,
  },
  selectedPackage: null,
  bumpPackages: null,
  shortlistPackages: null,
  selectedAssignmentId: '',
  selectedBumpPackage: {
    package_id: '',
    amount: 0,
    price: 0,
    assignment_id: '',
  },
  selectedShortlistPackage: {
    package_id: '',
    amount: 0,
    price: 0,
    assignment_id: '',
  },
  purchaseType: 'package',
};

export const subscriptionPackagesSlice = createSlice({
  name: 'subscription',
  initialState,
  reducers: {
    setSubscriptionPackages: (
      state,
      { payload }: PayloadAction<ISubscriptionPackages>
    ) => {
      state.packages = payload;
    },
    setSubscriptionPackage: (state, { payload }: PayloadAction<IPackage>) => {
      state.selectedPackage = payload;
    },
    setSubscriptionShortlistPackages: (
      state,
      { payload }: PayloadAction<ISubscriptionShortlistPackages[]>
    ) => {
      state.shortlistPackages = payload;
      state.selectedShortlistPackage = payload[0];
    },
    setSubscriptionBumpPackages: (
      state,
      { payload }: PayloadAction<ISubscriptionBumpPackages[]>
    ) => {
      state.bumpPackages = payload;
      state.selectedBumpPackage = payload[0];
    },
    setSelectedAssignmentId: (state, { payload }: PayloadAction<string>) => {
      state.selectedAssignmentId = payload;
    },
    setPaymentSubShortlistBump: (
      state,
      { payload }: PayloadAction<ISubscriptionBumpPackages>
    ) => {
      state.selectedBumpPackage = payload;
      state.selectedShortlistPackage = payload;
    },
    setSelectedBumpPackage: (
      state,
      action: PayloadAction<{ amount: number }>
    ) => {
      state.selectedBumpPackage =
        state.bumpPackages?.find(p => {
          return p.amount === action.payload.amount;
        }) || initialState.selectedBumpPackage;
    },
    setSelectedShortlistPackage: (
      state,
      action: PayloadAction<{ amount: number }>
    ) => {
      state.selectedShortlistPackage =
        state.shortlistPackages?.find(p => {
          return p.amount === action.payload.amount;
        }) || initialState.selectedShortlistPackage;
    },
    clearSelectedPackages: state => {
      state.selectedBumpPackage = initialState.selectedBumpPackage;
      state.selectedShortlistPackage = initialState.selectedShortlistPackage;
      // state.selectedAssignmentId = initialState.selectedAssignmentId;
      state.purchaseType = 'package';
    },
    setPurchaseType: (
      state,
      {
        payload,
      }: PayloadAction<'package' | 'bump' | 'shortlist' | string | null>
    ) => {
      state.purchaseType = payload;
    },
  },
});

export const {
  setSubscriptionPackages,
  setSubscriptionPackage,
  setSubscriptionShortlistPackages,
  setSubscriptionBumpPackages,
  setSelectedAssignmentId,
  setSelectedShortlistPackage,
  setSelectedBumpPackage,
  clearSelectedPackages,
  setPurchaseType,
  setPaymentSubShortlistBump,
} = subscriptionPackagesSlice.actions;

export default subscriptionPackagesSlice.reducer;
